import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, AppBar, Toolbar, Container, Typography, Button, IconButton, Drawer, List, ListItem, ListItemButton, ListItemText, useMediaQuery, useTheme, } from '@mui/material';
import { Menu as MenuIcon, Close } from '@mui/icons-material';
import { HeroSection } from './components/heroSection';
import { IndustriesSection } from './components/industriesSection';
import { PainPointsSection } from './components/painPointsSection';
import { HowItWorksSection } from './components/howItWorksSection';
import { TestimonialsSection } from './components/testimonialsSection';
import { FaqSection } from './components/faqSection';
import { CtaSection } from './components/ctaSection';
import { Footer } from './components/footer';
import { servicesColors as colors } from './theme';
const navItems = [
    { label: 'Industries', href: '#industries' },
    { label: 'How It Works', href: '#how-it-works' },
    { label: 'FAQ', href: '#faq' },
];
export const MainView = () => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    const scrollToSection = (href) => {
        const element = document.querySelector(href);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        setMobileOpen(false);
    };
    return (_jsxs(Box, { sx: { minHeight: '100vh' }, children: [_jsx(AppBar, { position: "fixed", elevation: 0, sx: {
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(10px)',
                    borderBottom: '1px solid',
                    borderColor: colors.divider,
                }, children: _jsx(Container, { maxWidth: "lg", children: _jsxs(Toolbar, { disableGutters: true, sx: { py: 1 }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1 }, children: [_jsx("img", { src: "/assets/st_logo.svg", alt: "StanorAI", style: { height: 28 } }), _jsx(Box, { sx: {
                                            display: { xs: 'none', sm: 'flex' },
                                            alignItems: 'center',
                                            px: 1.5,
                                            py: 0.5,
                                            backgroundColor: colors.primaryLight,
                                            borderRadius: 2,
                                        }, children: _jsx(Typography, { sx: {
                                                fontSize: '0.75rem',
                                                fontWeight: 600,
                                                color: colors.primary
                                            }, children: "Local Services" }) })] }), !isMobile && (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 }, children: [navItems.map((item) => (_jsx(Button, { onClick: () => scrollToSection(item.href), sx: {
                                            color: colors.text,
                                            fontWeight: 500,
                                            px: 2,
                                            '&:hover': {
                                                backgroundColor: colors.primaryLight,
                                            }
                                        }, children: item.label }, item.label))), _jsx(Button, { variant: "outlined", href: "/recruiter", sx: {
                                            ml: 1,
                                            borderColor: colors.primary,
                                            color: colors.primary,
                                            '&:hover': {
                                                borderColor: colors.primary,
                                                backgroundColor: colors.primaryLight,
                                            }
                                        }, children: "Sign In" }), _jsx(Button, { variant: "contained", href: "/onboarding?industry=services", sx: {
                                            ml: 1,
                                            background: colors.gradient,
                                            '&:hover': {
                                                background: colors.gradient,
                                                opacity: 0.9,
                                            }
                                        }, children: "Try Free" })] })), isMobile && (_jsx(IconButton, { onClick: handleDrawerToggle, sx: { color: colors.text }, children: _jsx(MenuIcon, {}) }))] }) }) }), _jsx(Drawer, { anchor: "right", open: mobileOpen, onClose: handleDrawerToggle, sx: {
                    '& .MuiDrawer-paper': {
                        width: 280,
                        backgroundColor: '#ffffff',
                    },
                }, children: _jsxs(Box, { sx: { p: 2 }, children: [_jsxs(Box, { sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }, children: [_jsx("img", { src: "/assets/st_logo.svg", alt: "StanorAI", style: { height: 24 } }), _jsx(IconButton, { onClick: handleDrawerToggle, children: _jsx(Close, {}) })] }), _jsx(List, { children: navItems.map((item) => (_jsx(ListItem, { disablePadding: true, children: _jsx(ListItemButton, { onClick: () => scrollToSection(item.href), children: _jsx(ListItemText, { primary: item.label, primaryTypographyProps: { fontWeight: 500 } }) }) }, item.label))) }), _jsxs(Box, { sx: { mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }, children: [_jsx(Button, { variant: "outlined", fullWidth: true, href: "/recruiter", sx: {
                                        borderColor: colors.primary,
                                        color: colors.primary,
                                    }, children: "Sign In" }), _jsx(Button, { variant: "contained", fullWidth: true, href: "/onboarding?industry=services", sx: {
                                        background: colors.gradient,
                                    }, children: "Try Free" })] })] }) }), _jsxs(Box, { component: "main", sx: { pt: 8 }, children: [_jsx(HeroSection, {}), _jsx(Box, { id: "industries", children: _jsx(IndustriesSection, {}) }), _jsx(PainPointsSection, {}), _jsx(Box, { id: "how-it-works", children: _jsx(HowItWorksSection, {}) }), _jsx(TestimonialsSection, {}), _jsx(Box, { id: "faq", children: _jsx(FaqSection, {}) }), _jsx(CtaSection, {}), _jsx(Footer, {})] })] }));
};
